export const capitalize = (text: string): string => {
  return text[0].toUpperCase() + text.slice(1).toLowerCase();
};

export const undash = (text: string): string => {
  return text.split('-').join(' ').split('_').join(' ');
};

export const getBlockName = (text: string): string => {
  if (text === 'info-card') {
    return 'Card';
  }
  if (text === 'tiles') {
    return 'Card group';
  }
  if (text === 'code') {
    return 'HTML/CSS Block';
  }
  if (text === 'hero-counsalting') {
    return 'Hero consulting';
  }
  if (text === 'process-state') {
    return 'Process progress';
  }
  if (text === 'process-action') {
    return 'Process buttons';
  }
  if (text === 'text') {
    return 'Simple text';
  }
  if (text === 'title') {
    return 'Heading';
  }
  if (text === 'integration') {
    return 'Table';
  }
  if (text === 'ai-agent') {
    return 'AI Agent';
  }
  return capitalize(undash(text));
};

/**
 * Adds a prefix to each word in a string (split by spaces) or to each item in an array of strings.
 */
export const prefix = (prefix: string, source: string | string[]): string => {
  const arr = typeof source === 'string' ? source.trim().split(/\s+/) : source;
  return prefix + arr.join(` ${prefix}`);
};
